import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { useRouter } from 'vue-router/composables';
import TwoFactorVerificationForm from '@/components/pages/auth/TwoFactorVerificationForm.vue';
import { readLoginTokenSubject } from '@/other/loginToken';
import { guidesJourneyQuery, isGuidesContext } from '@/helpers/appContext';
import { LOGIN } from '@/routerNames';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginSocialTwoFactorPage',
  props: {
    loginToken: null
  },
  setup(__props: any, { expose }) {

const props = __props as { loginToken: string }

/**
 * SNAP-2366 — landing page for `#/login/social-2fa/:loginToken`.
 *
 * The Google OAuth callback redirects here instead of `#/login/social/:token`
 * when the user's company mandates 2FA. The route only exists so the browser
 * has somewhere to land once the backend's ENFORCE_2FA_ON_GOOGLE_LOGIN flag is
 * switched on; until then nothing redirects here and Google login is unchanged.
 */


const router = useRouter();

// The token is fixed for the life of this page (it comes from the route param),
// so a plain read is enough — no reactivity needed.
const userId = readLoginTokenSubject(props.loginToken);
const message = 'Check your email for the verification code';

const goBackToLogin = () => {
  // A bare login would end a Guides journey (see LoginSocialFailPage).
  router.push({ name: LOGIN, query: isGuidesContext() ? guidesJourneyQuery() : {} });
};

onMounted(() => {
  // A token we cannot read is a token the API would reject anyway. Bail to the
  // login form rather than leaving the user on a blank page.
  if (!userId) goBackToLogin();
});

expose({ userId });

return { __sfc: true,props, router, userId, message, goBackToLogin, TwoFactorVerificationForm }
}

})